import { render, staticRenderFns } from "./contractReview.vue?vue&type=template&id=1dbb7f96"
import script from "./contractReview.vue?vue&type=script&lang=js"
export * from "./contractReview.vue?vue&type=script&lang=js"
import style0 from "./contractReview.vue?vue&type=style&index=0&id=1dbb7f96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports